import React from 'react';
import { useParams } from 'react-router-dom';
import Loadable from 'react-loadable';
import { getApplicationByNumber } from 'api';
import LoadableLoading from 'components/LoadableLoading';
import { getStatuses } from './api';

export const path = '/application/:applicationNumber';
export const getPath = (applicationNumber: string) => `/application/${applicationNumber}`;

const PageApplication: React.FC = (props) => {
  const { applicationNumber } = useParams<{ applicationNumber: string }>();

  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      application: () => getApplicationByNumber(applicationNumber),
      statuses: getStatuses,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageApplication;
